import CloseRounded from "@mui/icons-material/CloseRounded";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { atom, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import React from "react";

export const topNotificationAtom = atom(false);

export const topNotificationLocalAtom = atom(false);

export const topNotificationDialogAtom = atomWithStorage(
  "is-printy6-top-notification-dialog-open-20260205",
  false,
);
// export const topNotificationLocalAtom = atomWithStorage(
//   "is-printy6-top-notification-open",
//   true
// );

export default function TopNotification() {
  const [localOpen, setLocalOpen] = useAtom(topNotificationLocalAtom);

  const [open, setOpen] = useAtom(topNotificationAtom);

  const [openDialog, setOpenDialog] = useAtom(topNotificationDialogAtom);

  const handleDialogClose = () => setOpenDialog(false);

  const handleClose = React.useCallback(() => {
    setLocalOpen(false);
  }, []);

  React.useEffect(() => {
    setOpen(localOpen);
  }, [localOpen]);

  const handleOpenDialog = React.useCallback(() => {
    setOpenDialog(true);
  }, []);

  if (!open) {
    return <></>;
  }

  return (
    <Box
      sx={(theme) => ({
        height: 40,
        background: theme.palette.grey[900],
        color: theme.palette.common.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      <Box sx={{ width: 40 }}></Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        ⚠️&nbsp;&nbsp;&nbsp;
        <Typography
          // href="/page/holiday-notice/"
          variant="body2"
          // color="#ffffff"
          // underline="always"
          onClick={handleOpenDialog}
          sx={{
            cursor: "pointer",
            textDecoration: "underline",
            textDecorationColor: "#ffffff !important",
          }}
        >
          Notice of Spring Festival Holiday
        </Typography>
      </Box>
      <Box sx={{ width: 40 }}>
        <IconButton
          onClick={handleClose}
          sx={(theme) => ({
            color: theme.palette.common.white,
            // ml: "auto",
            justifyContent: "flex-end",
          })}
        >
          <CloseRounded />
        </IconButton>
      </Box>
      <NotificationDialog open={openDialog} handleClose={handleDialogClose} />
    </Box>
  );
}

const NotificationDialog = (props: {
  open: boolean;
  handleClose: () => void;
}) => {
  const { open, handleClose } = props;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Notice of Spring Festival Holiday
        </Typography>

        <Stack spacing={2} sx={{ mt: 2 }}>
          <Typography>Dear customers around the world,</Typography>
          <Typography>
            As the Spring Festival in China is approaching, to allow our
            employees to have a good time with their families and serve you
            better afterwards, Printy6 will follow the national statutory
            holiday arrangement. Here is the notice about the holiday:
          </Typography>

          <Box
            sx={{
              bgcolor: "grey.100",
              borderRadius: 1,
              p: 2,
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              🗓 Holiday Time
            </Typography>
            <Typography>
              From <strong>February 13th</strong> to{" "}
              <strong>February 21st</strong>, a total of <strong>9 days</strong>
              .
            </Typography>

            <Typography
              variant="subtitle1"
              fontWeight="bold"
              gutterBottom
              sx={{ mt: 2 }}
            >
              🔔 Resumption of Business
            </Typography>
            <Typography>
              We will resume normal business on <strong>February 22nd</strong>.
            </Typography>
          </Box>

          <Typography variant="subtitle1" fontWeight="bold">
            📦 Order Processing
          </Typography>
          <Typography>
            You can still place orders on our platform as usual during the
            holiday. The order processing arrangements are as follows:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 3 }}>
            <li>
              <Typography>
                Orders placed on or before <strong>February 7th</strong> will be
                shipped before the holiday if possible.
              </Typography>
            </li>
            <li>
              <Typography>
                Orders placed after <strong>February 7th</strong> will be
                processed after we return from the holiday.
              </Typography>
            </li>
          </Box>
          <Typography>
            All orders to be processed after the holiday will be handled in the
            order of receipt starting from the first working day after the
            holiday (<strong>February 22nd</strong>). Please be patient with us.
            If your order is urgent, please indicate it when placing the order,
            and we will prioritize it upon our return.
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold">
            ✉️ Email Response
          </Typography>
          <Typography>
            During the holiday, we have arranged on-duty staff to check
            consultation emails irregularly. However, due to the limited number
            of on-duty staff, email responses may not be as prompt as on
            weekdays. We sincerely hope for your understanding. We will do our
            best to reply to your emails as soon as we see them.
          </Typography>

          <Typography>
            We apologize for any inconvenience the holiday may bring to your
            shopping. Rest assured that after the holiday, we will offer
            high-quality products and services with more enthusiasm and
            professionalism.
          </Typography>

          <Typography>
            Thank you for your continuous support and trust. Wish you a
            prosperous and happy Spring Festival! 🎉
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Typography fontWeight="bold">Printy6 Support Team</Typography>
            <Typography variant="body2" color="text.secondary">
              Feb 4th, 2026
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Got It
        </Button>
      </DialogActions>
    </Dialog>
  );
};
